import { useSearchBox } from 'react-instantsearch-hooks-web';
import { InputAdornment, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface SearchBoxProps<C = React.ElementType> {
  readonly component?: C;
}

export const SearchBox = <C extends React.ElementType = typeof OutlinedInput>({
  component: Component = OutlinedInput, ...restProps
}: SearchBoxProps<C> & React.ComponentPropsWithRef<C>) => {
  const { query, refine } = useSearchBox();

  return (
    <Component
      placeholder="Search"
      size="small"
      defaultValue={query}
      onChange={(e) => {
        refine(e.currentTarget.value);
      }}
      startAdornment={(
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      )}
      {...restProps}
    />
  );
};
